import { UpdatePasswordRequest } from '@sic-lib/types/Password';
import { AxiosPromise } from 'axios';
import { EditUserTwilioPhoneData } from '../../types/EditUserTwilioPhoneData';
import { EditUserData, NewUserData } from '../../types/NewEditUser';
import { libApiInstance } from '../axios';

export function requestUpdateUser(data: EditUserData, signal?: AbortSignal): AxiosPromise<boolean> {
    return libApiInstance.put('/users', data, {
        signal,
    });
}

export function requestCreateUser(
    data: NewUserData,
    signal?: AbortSignal,
): AxiosPromise<NewUserData> {
    return libApiInstance.post('/users', data, {
        signal,
    });
}

export function requestEditUsers(signal?: AbortSignal): AxiosPromise<EditUserData[]> {
    return libApiInstance.get('/users', {
        signal,
    });
}

export function requestEditUser(
    userName: string | undefined,
    signal?: AbortSignal,
): AxiosPromise<EditUserData> {
    return libApiInstance.get(`/users/${userName}`, {
        signal,
    });
}

export function requestUsersPhoneSettings(
    signal?: AbortSignal,
): AxiosPromise<EditUserTwilioPhoneData> {
    return libApiInstance.get('/users/phoneSettings', {
        signal,
    });
}

export function requestUpdateUsersPhoneSettings(
    data: EditUserTwilioPhoneData,
    signal?: AbortSignal,
): AxiosPromise<boolean> {
    return libApiInstance.put('/users/phoneSettings', data, {
        signal,
    });
}

export function requestUpdatePassword(
    data: UpdatePasswordRequest,
    signal?: AbortSignal,
): AxiosPromise<boolean> {
    return libApiInstance.put('/users/password', data, {
        signal,
    });
}
